import React, { useContext, useState } from "react";

import Head from "next/head";

import { EmedLogo } from "./EmedLogo";
import { MetricsContext } from "../providers/MetricsProvider";
import { ShemedLogo, HemedLogo } from "@emed-labs/ui-kit";
import { Theme } from "../models/NavigatorModels";
import { ThemeContext } from "../providers/ThemeProvider";

export interface SiteFooterProps {
	title?: string;
	pageTitle?: string;
	white?: boolean;
	environmentTag?: string;
	showMetricsDebug?: boolean;
	centerContent?: boolean;
}

export const SiteFooter: React.FC<SiteFooterProps> = (props) => {
	const { theme } = useContext(ThemeContext);
	const MetricsCtx = useContext(MetricsContext);
	const [pressAmount, setPressAmount] = useState(0);
	const [showMetrics, setShowMetrics] = useState(false);

	/**
	 * in prod, clicking footer 10 times will show metrics button
	 */
	const onClick = () => {
		if (pressAmount > 10) {
			setShowMetrics(true);
		} else {
			setPressAmount(pressAmount + 1);
		}
	};

	let pageTitle = props.pageTitle ?? props.title;
	const logoItem =
		theme === Theme.SheMed ? (
			<ShemedLogo className="w-[96px]" />
		) : theme === Theme.HeMed ? (
			<HemedLogo className="w-[96px]" />
		) : (
			<EmedLogo isLight={!props.white} />
		);

	const titleItem = props.title ? (
		<div className="is-hidden-mobile is-size-5 has-text-weight-light is-uppercase">{props.title}</div>
	) : null;

	if (pageTitle) {
		pageTitle += " - ";
	} else {
		pageTitle = "";
	}

	pageTitle += "eMed";

	return (
		<>
			<Head>
				<title>{pageTitle}</title>
			</Head>
			<footer
				className={`level px-5 py-5 ${
					props.white ? "has-background-white" : "has-background-black has-text-white"
				} is-shadowed`}
				style={{ zIndex: 5 }}
				onClick={onClick}
			>
				<div className="level-left">{props.centerContent ? null : <div className="level-item">{logoItem}</div>}</div>
				{props.centerContent ? (
					<div>
						<div className="level-item">
							<div className="px-5 is-flex">{logoItem}</div>
							<div
								className="px-5 is-hidden-mobile"
								style={{
									borderLeft: `1px solid ${props.white ? "black" : "white"}`
								}}
							>
								{titleItem}
							</div>
						</div>
					</div>
				) : null}
				<div className="level-right is-hidden-mobile">
					{props.centerContent ? null : <div className="level-item">{titleItem}</div>}
					{props.showMetricsDebug && (props.environmentTag || showMetrics) ? (
						<a className="level-item" onClick={MetricsCtx.toggleDebugMetrics}>
							<span className="tag is-warning">METRICS</span>
						</a>
					) : null}
					{props.environmentTag ? (
						<div className="level-item">
							<span className="tag is-warning">{props.environmentTag.toUpperCase()}</span>
						</div>
					) : null}
				</div>
			</footer>
		</>
	);
};
